// import React, { useEffect, useState } from "react";
// import {
//   FaCoins,
//   FaChartLine,
//   FaSignal,
//   FaCheckCircle,
//   FaArrowRight,
//   FaDesktop,
//   FaFileInvoiceDollar,
//   FaSpinner,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import LoanEligibilitySDK, { SDKEvent } from "loan-eligibility-sdk";
// import authService from "../../services/api/auth.service";
// import axios from "axios";
// import casdataService from "../../services/api/casdata.service";

// type SDKStatus = "idle" | "loading" | "success" | "error" | "completed";

// interface Scheme {
//   age: number;
//   amc: string;
//   nav: number;
//   bank: {
//     city: string;
//     ifsc: string;
//     micr: string;
//     name: string;
//     branch: string;
//     pincode: string;
//     accountNo: string;
//     accountType: string;
//   };
//   dpId: string;
//   isin: string;
//   email: string;
//   folio: string;
//   mobile: string;
//   amcName: string;
//   isDemat: string;
//   navDate: string;
//   rtaName: string;
//   gainLoss: number;
//   planMode: string;
//   purAllow: string;
//   redAllow: string;
//   sipAllow: string;
//   stpAllow: string;
//   swpAllow: string;
//   swtAllow: string;
//   assetType: string;
//   costValue: number;
//   kycStatus: string;
//   taxStatus: string;
//   brokerCode: string;
//   brokerName: string;
//   decimalNav: number;
//   schemeCode: string;
//   schemeName: string;
//   schemeType: string;
//   decimalUnits: number;
//   investorName: string;
//   schemeOption: string;
//   decimalAmount: number;
//   lienUnitsFlag: string;
//   modeOfHolding: string;
//   nomineeStatus: string;
//   availableUnits: number;
//   closingBalance: number;
//   availableAmount: number;
//   currentMktValue: number;
//   idcwChangeAllowed: string;
//   lienEligibleUnits: number;
//   transactionSource: string;
//   gainLossPercentage: number;
// }

// interface PortfolioItem {
//   schemes: Scheme[];
//   summary: {
//     amc: string;
//     amcName: string;
//     isDemat: string;
//     gainLoss: number;
//     costValue: number;
//     currentMktValue: number;
//     gainLossPercentage: number;
//   }[];
// }

// interface LoanOffer {
//   loanProvider: string;
//   timeDuration: string;
//   rateOfInterest: string;
//   totalLoanAmount: number;
// }

// interface LoanOffersResponse {
//   bestOffers: LoanOffer[];
//   otherOffers: LoanOffer[];
//   totalPortfolio: PortfolioItem[];
//   eligibleFunds: Scheme[];
//   nonEligibleFunds: Scheme[];
// }

// const transformLoanOffersData = (newData: any): LoanOffersResponse => {
//   const bestOffers: LoanOffer[] =
//     newData.bestOffers?.map((offer: any) => ({
//       loanProvider: offer.loanProvider || "Unknown",
//       timeDuration: offer.timeDuration || "N/A",
//       rateOfInterest: offer.rateOfInterest || "N/A",
//       totalLoanAmount: offer.totalLoanAmount || 0,
//     })) || [];

//   const otherOffers: LoanOffer[] =
//     newData.otherOffers?.map((offer: any) => ({
//       loanProvider: offer.loanProvider || "Unknown",
//       timeDuration: offer.timeDuration || "N/A",
//       rateOfInterest: offer.rateOfInterest || "N/A",
//       totalLoanAmount: offer.totalLoanAmount || 0,
//     })) || [];

//   const totalPortfolio: PortfolioItem[] = newData.totalPortfolio || [];
//   const eligibleFunds: Scheme[] = newData.eligibleFunds || [];
//   const nonEligibleFunds: Scheme[] = newData.nonEligibleFunds || [];

//   return {
//     bestOffers,
//     otherOffers,
//     totalPortfolio,
//     eligibleFunds,
//     nonEligibleFunds,
//   };
// };

// interface ProfileData {
//   data?: {
//     phone_no: string;
//     id: string;
//     customer?: {
//       application_status?: string;
//     };
//   };
//   id?: string;
// }

// const LoanApp: React.FC = () => {
//   const [sdk, setSdk] = useState<LoanEligibilitySDK | null>(null);
//   const [status, setStatus] = useState<SDKStatus>("idle");
//   const [message, setMessage] = useState("Check Eligibility");
//   const [error, setError] = useState<string | null>(null);
//   const [profile, setProfile] = useState<ProfileData | null>(null);
//   const [loanOffers, setLoanOffers] = useState<LoanOffersResponse | null>(null);
//   const [showPortfolioNotFound, setShowPortfolioNotFound] = useState(false);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showOfferNotFoundPopup, setShowOfferNotFoundPopup] = useState(false);
//   const [isRedirecting, setIsRedirecting] = useState(false);

//   // Helper function to get appropriate button message based on application status
//   const getButtonMessage = (applicationStatus?: string) => {
//     if (
//       !applicationStatus ||
//       applicationStatus === "null" ||
//       applicationStatus === "PORTFOLIO_NOT_FOUND" ||
//       applicationStatus === "OFFER_NOT_FOUND"
//     ) {
//       return "Check Eligibility";
//     } else {
//       return "Get Cash";
//     }
//   };

//   // Helper function to handle redirect with loader
//   const handleRedirectToVerifyEmail = () => {
//     setIsRedirecting(true);
//     // Small delay to show the loader before redirect
//     setTimeout(() => {
//       window.location.href = `${process.env.REACT_APP_REDIRECT_URL}/verify-email`;
//     }, 500);
//   };

//   // Helper function to handle redirect to loan apply with loader
//   const handleRedirectToLoanApply = () => {
//     setIsRedirecting(true);
//     // Small delay to show the loader before redirect
//     setTimeout(() => {
//       window.location.href = `${process.env.REACT_APP_REDIRECT_URL}/loan/apply`;
//     }, 500);
//   };

//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const data = await authService.getProfile();
//         if (!data?.data?.phone_no) {
//           throw new Error("Phone number not found in profile");
//         }
//         setProfile(data);

//         const applicationStatus = data.data?.customer?.application_status;
//         setMessage(getButtonMessage(applicationStatus));
//       } catch (err) {
//         console.error("Failed to fetch profile:", err);
//         setError("Failed to fetch user profile");
//       }
//     };

//     fetchProfile();
//   }, []);

//   const fetchLoanOffers = async (phoneNumber: string) => {
//     try {
//       const response = await axios.get(
//         `https://backend-sdk.larkfinserv.in/loan-sdk/get-offers-admin?partnerId=${process.env.REACT_APP_PARTNER_ID}&mobileNumber=+91${phoneNumber}`
//       );
//       return response.data;
//     } catch (error) {
//       console.error("Error fetching loan offers:", error);
//       throw error;
//     }
//   };

//   const syncPortfolioData = async () => {
//     if (!profile?.data?.phone_no) return;

//     try {
//       console.log("Starting automatic portfolio sync...");

//       // This will now fetch from both APIs and combine the data
//       const result = await casdataService.syncPortfolioData(
//         Number(profile.data.id),
//         profile.data.phone_no
//       );

//       if (result) {
//         console.log("Portfolio data synced successfully:", result);
//       } else {
//         console.warn("Portfolio sync returned no data");
//       }
//     } catch (err) {
//       console.error("Automatic portfolio sync failed:", err);
//     }
//   };

//   const fetchLoanOffersUser = async (phoneNumber: string) => {
//     try {
//       const response = await axios.post(
//         "https://backend-sdk.larkfinserv.in/loan-sdk/get-offers",
//         {
//           phone: `+91${phoneNumber}`, // Assuming you want to add +91 prefix
//         },
//         {
//           headers: {
//             Origin: "https://sdk-fe.larkfinserv.in",
//             Referer: "https://sdk-fe.larkfinserv.in/",
//             "X-SDK-Key": process.env.REACT_APP_SDK_KEY,
//             "X-SDK-Secret": process.env.REACT_APP_SDK_SECRET,
//           },
//         }
//       );
//       return response.data;
//     } catch (error) {
//       console.error("Error fetching loan offers:", error);
//       throw error;
//     }
//   };

//   useEffect(() => {
//     const initializeSdk = async () => {
//       try {
//         const sdkInstance = new LoanEligibilitySDK({
//           apiKey: process.env.REACT_APP_SDK_KEY!,
//           apiSecret: process.env.REACT_APP_SDK_SECRET!,
//           phoneNumber: `+91${profile?.data?.phone_no}`,
//         });

//         const onInitiated = () => {
//           setStatus("loading");
//           setMessage("Loading eligibility check...");
//         };

//         const onReady = async () => {
//           setMessage("Please complete the form");
//         };

//         const onCompleted = async (event: SDKEvent) => {
//           try {
//             setTimeout(() => {
//               console.log("Eligibility Check Completed:", event.data);
//             }, 5000);

//             // Check if the result contains "User is not eligible for any offer"
//             const resultMessage = (event.data?.result as any)?.message;
//              let transformedData;
//             if (profile?.data?.id && profile?.data?.phone_no) {

//               const userData = await fetchLoanOffersUser(profile.data.phone_no);
//               transformedData = transformLoanOffersData(userData);
//               setLoanOffers(transformedData);
//             }

//             console.log("Eligibility Result:", resultMessage);
//             if (
//               resultMessage &&
//               resultMessage.includes("User is not eligible for any offer")
//             ) {
//               console.log("No offers found for the user");
//               if (profile?.data?.id) {
//                 await authService.updateApplicationStatus(
//                   profile.data.id,
//                   null,
//                   "OFFER_NOT_FOUND"
//                 );
//               }
//               setStatus("idle");
//               const applicationStatus =
//                 profile?.data?.customer?.application_status;
//               console.log("Application Status:", applicationStatus);
//               setMessage(getButtonMessage("OFFER_NOT_FOUND"));
//               setShowOfferNotFoundPopup(true);
//               // Close the SDK frame
//               if (sdk) {
//                 sdk.closeFrame();
//               }
//               return;
//             }

//             if (profile?.data?.id && profile?.data?.phone_no) {
//               const offersData = await fetchLoanOffers(profile.data.phone_no);
//               const userData = await fetchLoanOffersUser(profile.data.phone_no);

//               // Check if offersData.data is null
//               if (userData.data === null) {
//                 // Show the message from the response
//                 setStatus("error");
//                 setError(
//                   offersData.message ||
//                     "Sorry, you're not eligible for a loan at this time"
//                 );
//                 const applicationStatus =
//                   profile?.data?.customer?.application_status;
//                 setMessage(getButtonMessage(applicationStatus));
//                 // Close the SDK frame
//                 if (sdk) {
//                   sdk.closeFrame();
//                 }
//                 return;
//               }

//               // If data is not null, proceed with success flow
//               const transformedData = transformLoanOffersData(offersData);
//               setLoanOffers(transformedData);

//               await authService.updateApplicationStatus(
//                 profile.data.id,
//                 JSON.stringify(transformedData),
//                 "ELIGIBILITY_CHECKED"
//               );

//               setStatus("completed");
//               setMessage("Get Cash");
//               setShowSuccessPopup(true);
//               syncPortfolioData();
//               // Redirect with loader after successful completion
//               // handleRedirectToVerifyEmail();
//             }
//           } catch (err) {
//             console.error("Failed to update application status:", err);
//             // Close the SDK frame before redirecting
//             if (sdk) {
//               sdk.closeFrame();
//             }
//             // Even if update fails, still redirect with loader
//             // handleRedirectToVerifyEmail();
//           }
//         };

//         const onError = (event: SDKEvent) => {
//           setStatus("error");
//           setError(event.data?.error?.message || "An error occurred");
//           const applicationStatus = profile?.data?.customer?.application_status;
//           setMessage(getButtonMessage(applicationStatus));
//           console.error("SDK Error:", event);
//         };

//         const onPortfolioNotFound = async (event: SDKEvent) => {
//           console.log("Portfolio Not Found Event:", event);
//           // Immediately reset status and message
//           setStatus("idle");
//           const applicationStatus = profile?.data?.customer?.application_status;
//           setMessage(getButtonMessage("PORTFOLIO_NOT_FOUND"));
//           // Close the SDK frame
//           if (sdk) {
//             sdk.closeFrame();
//           }
//         };

//         const onClosed = () => {
//           // Immediately reset status and message when SDK closes
//           setStatus("idle");
//           const applicationStatus = profile?.data?.customer?.application_status;
//           setMessage(getButtonMessage(applicationStatus));
//           // Close the SDK frame
//           if (sdk) {
//             sdk.closeFrame();
//           }
//         };

//         sdkInstance.on("INITIATED", onInitiated);
//         sdkInstance.on("READY", onReady);
//         sdkInstance.on("ELIGIBILITY_RESULT", onCompleted);
//         sdkInstance.on("ERROR", onError);
//         sdkInstance.on("CLOSE", onClosed);
//         sdkInstance.on("CLOSE_FRAME", onPortfolioNotFound);

//         setSdk(sdkInstance);

//         return () => {
//           sdkInstance.off("INITIATED", onInitiated);
//           sdkInstance.off("READY", onReady);
//           sdkInstance.off("ELIGIBILITY_RESULT", onCompleted);
//           sdkInstance.off("ERROR", onError);
//           sdkInstance.off("CLOSE", onClosed);
//           sdkInstance.off("CLOSE_FRAME", onPortfolioNotFound);
//           // Close the SDK frame when component unmounts
//           sdkInstance.closeFrame();
//         };
//       } catch (err) {
//         setStatus("error");
//         setError("Failed to initialize SDK");
//         const applicationStatus = profile?.data?.customer?.application_status;
//         setMessage(getButtonMessage(applicationStatus));
//         console.error("Initialization error:", err);
//       }
//     };

//     if (profile?.data?.phone_no) {
//       initializeSdk();
//     }
//   }, [profile, status]);

//   const handleClick = async () => {
//     if (!profile || !profile.data || !profile.data.phone_no) {
//       setError("Phone number not available");
//       return;
//     }

//     let applicationStatus = profile.data.customer?.application_status;
//     if (!applicationStatus) applicationStatus = "null";

//     switch (applicationStatus.toUpperCase()) {
//       case "NULL":
//       case "PORTFOLIO_NOT_FOUND":
//         if (!sdk) {
//           setError("SDK not initialized");
//           return;
//         }
//         try {
//           setError(null);
//           await sdk.initialize({
//             apiKey: process.env.REACT_APP_SDK_KEY!,
//             apiSecret: process.env.REACT_APP_SDK_SECRET!,
//             phoneNumber: `+91${profile.data.phone_no}`,
//           });
//           sdk.openEligibilityCheck("inline");
//         } catch (err) {
//           setStatus("error");
//           setError("Failed to open eligibility check");
//           setMessage(getButtonMessage(applicationStatus));
//           console.error("Open error:", err);
//           // Close the SDK frame on error
//           if (sdk) {
//             sdk.closeFrame();
//           }
//         }
//         break;

//       case "EMAIL_VERIFIED":
//         handleRedirectToLoanApply();
//         break;

//       case "ELIGIBILITY_CHECKED":
//       default:
//         if (
//           applicationStatus.toUpperCase() !== "PORTFOLIO_NOT_FOUND" &&
//           applicationStatus.toUpperCase() !== "OFFER_NOT_FOUND" &&
//           applicationStatus.toUpperCase() !== "NULL"
//         ) {
//           handleRedirectToLoanApply();
//         } else {
//           handleRedirectToVerifyEmail();
//         }
//         break;
//     }
//   };

//   const handleSuccessPopupClose = () => {
//     setShowSuccessPopup(false);
//     // Close the SDK frame before redirecting
//     if (sdk) {
//       sdk.closeFrame();
//     }
//     handleRedirectToVerifyEmail();
//   };

//   const handleOfferNotFoundPopupClose = () => {
//     setShowOfferNotFoundPopup(false);
//     setError(null);
//     // Reset button message to appropriate state
//     const applicationStatus = profile?.data?.customer?.application_status;
//     setMessage(getButtonMessage("OFFER_NOT_FOUND"));
//     // Close the SDK frame
//     if (sdk) {
//       sdk.closeFrame();
//     }
//   };

//   return (
//     <div className="min-h-screen p-5 font-sans">
//       {/* Redirect Loader Overlay */}
//       {isRedirecting && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
//             <div className="mb-4">
//               <FaSpinner className="text-green-600 text-4xl mx-auto animate-spin" />
//             </div>
//             <h3 className="text-xl font-bold text-gray-800 mb-2">
//               Redirecting...
//             </h3>
//             <p className="text-gray-600">
//               Please wait while we redirect you to the next step.
//             </p>
//           </div>
//         </div>
//       )}

//       <div className="max-w-6xl mx-auto bg-white shadow-2xl rounded-3xl overflow-hidden border border-gray-100">
//         {/* Hero Section */}
//         <div className="bg-gradient-to-r from-green-600 to-green-800 text-white p-8 relative">
//           <div className="absolute inset-0 opacity-10 bg-pattern"></div>
//           <div className="relative">
//             <div className="flex justify-between items-center">
//               <div>
//                 <h1 className="text-4xl font-bold mb-4 tracking-tight">
//                   Instant Cash Against Mutual Funds
//                 </h1>
//                 <p className="text-xl text-green-100 mb-6">
//                   Unlock financial flexibility without selling your investments
//                 </p>
//               </div>
//               <div className="bg-white/20 p-4 rounded-2xl">
//                 <div className="flex space-x-4">
//                   <div className="text-center">
//                     <span className="block text-sm text-green-100">
//                       Credit Card
//                     </span>
//                     <span className="font-bold text-white text-lg">35%</span>
//                   </div>
//                   <div className="text-center">
//                     <span className="block text-sm text-green-100">
//                       Personal Loan
//                     </span>
//                     <span className="font-bold text-white text-lg">18%</span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-8 flex items-center space-x-4">
//               <button
//                 onClick={handleClick}
//                 className={`bg-white text-green-800 hover:bg-green-50 font-bold py-3 px-6 rounded-xl transition transform hover:scale-105 flex items-center space-x-2 ${
//                   status === "loading" || isRedirecting
//                     ? "opacity-50 cursor-not-allowed"
//                     : ""
//                 }`}
//                 disabled={status === "loading" || isRedirecting}
//               >
//                 {isRedirecting ? (
//                   <>
//                     <FaSpinner className="animate-spin" />
//                     <span>Redirecting...</span>
//                   </>
//                 ) : (
//                   <>
//                     <span>{status === "loading" ? "Loading..." : message}</span>
//                     <FaArrowRight />
//                   </>
//                 )}
//               </button>
//               <div className="bg-white/20 px-4 py-2 rounded-xl">
//                 <span className="text-lg font-semibold">
//                   Loans Up to ₹5 Crores
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Features */}
//         <div className="grid md:grid-cols-3 gap-6 p-8">
//           <button className="bg-green-50 border border-green-100 rounded-2xl p-6 hover:shadow-xl transition-all group">
//             <div className="flex items-center justify-between mb-4">
//               <FaCoins className="text-green-600 text-3xl" />
//               <span className="text-green-700 font-bold text-xl">
//                 Start from 10.25% p.a.
//               </span>
//             </div>
//             <h3 className="text-xl font-bold text-green-800 mb-2">
//               Loan Against Mutual Fund <FaArrowRight />
//             </h3>
//             <p className="text-green-700">
//               Better rates than traditional personal loans
//             </p>
//           </button>

//           <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6 hover:shadow-xl transition-all group">
//             <div className="flex items-center justify-between mb-4">
//               <FaChartLine className="text-blue-600 text-3xl" />
//               <span className="text-blue-700 font-bold text-xl">50% LTV</span>
//             </div>
//             <h3 className="text-xl font-bold text-blue-800 mb-2">
//               Loan Against Stocks
//             </h3>
//             <p className="text-blue-700">
//               Get loan value against your stock portfolio
//             </p>
//           </div>

//           <button className="bg-purple-50 border border-purple-100 rounded-2xl p-6 hover:shadow-xl transition-all group">
//             <div className="flex items-center justify-between mb-4">
//               <FaSignal className="text-purple-600 text-3xl" />
//               <FaCheckCircle className="text-green-500" />
//             </div>
//             <h3 className="text-xl font-bold text-purple-800 mb-2">
//               Quick Eligibility <FaArrowRight />
//             </h3>
//             <p className="text-purple-700">
//               Instant digital verification process
//             </p>
//           </button>
//         </div>

//         {/* Benefits */}
//         <div className="bg-gray-100 p-8 grid md:grid-cols-2 gap-8">
//           <div>
//             <h2 className="text-3xl font-bold text-green-800 mb-6">
//               Why Choose Us?
//             </h2>
//             <div className="space-y-6">
//               <div className="flex items-start space-x-4">
//                 <FaDesktop className="text-green-600 text-2xl mt-1" />
//                 <div>
//                   <h4 className="font-bold text-green-800 mb-2">
//                     100% Digital Process
//                   </h4>
//                   <p className="text-gray-600">
//                     Paperless application with instant processing
//                   </p>
//                 </div>
//               </div>
//               <div className="flex items-start space-x-4">
//                 <FaFileInvoiceDollar className="text-blue-600 text-2xl mt-1" />
//                 <div>
//                   <h4 className="font-bold text-blue-800 mb-2">
//                     Zero Pre-Closure Charges
//                   </h4>
//                   <p className="text-gray-600">
//                     Complete flexibility in loan repayment
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div>
//             <h2 className="text-3xl font-bold text-green-800 mb-6">
//               How It Works
//             </h2>
//             <p className="text-gray-700 leading-relaxed">
//               Loan Against Securities (LAS) is a secure way to leverage your
//               investments. Pledge your mutual funds or stocks as collateral and
//               access funds without disrupting your investment strategy.
//             </p>
//           </div>
//         </div>

//         {/* CTA Footer */}
//         <div className="bg-green-700 text-white text-center p-12">
//           <h3 className="text-3xl font-bold mb-6">
//             Get Instant Financial Flexibility
//           </h3>
//           <button
//             onClick={handleClick}
//             className={`bg-white w-fit text-green-800 hover:bg-green-50 font-bold py-4 px-10 rounded-xl
//               transition transform hover:scale-105 flex items-center space-x-3 mx-auto ${
//                 status === "loading" || isRedirecting
//                   ? "opacity-50 cursor-not-allowed"
//                   : ""
//               }`}
//             disabled={status === "loading" || isRedirecting}
//           >
//             {isRedirecting ? (
//               <>
//                 <FaSpinner className="animate-spin" />
//                 <span className="text-lg">Redirecting...</span>
//               </>
//             ) : (
//               <>
//                 <span className="text-lg">
//                   {status === "loading" ? "Loading..." : message}
//                 </span>
//                 <FaArrowRight />
//               </>
//             )}
//           </button>
//         </div>

//         {/* Error Message */}
//         {error && (
//           <div className="p-4 text-red-500 text-center">
//             <p>{error}</p>
//           </div>
//         )}

//         {/* Portfolio Not Found Popup */}
//         {showPortfolioNotFound && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//             <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
//               <h3 className="text-2xl font-bold text-gray-800 mb-4">
//                 Portfolio Not Found
//               </h3>
//               <p className="text-gray-600 mb-6">
//                 We couldn't find your investment portfolio. Please check your
//                 details and try again.
//               </p>
//               <button
//                 onClick={() => {
//                   setShowPortfolioNotFound(false);
//                   setError(null);
//                   const applicationStatus =
//                     profile?.data?.customer?.application_status;
//                   setMessage(getButtonMessage("PORTFOLIO_NOT_FOUND"));
//                   // Close the SDK frame
//                   if (sdk) {
//                     sdk.closeFrame();
//                   }
//                 }}
//                 className="bg-green-600 text-white font-bold py-3 px-6 rounded-xl w-full hover:bg-green-700 transition"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Offer Not Found Popup */}
//         {showOfferNotFoundPopup && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//             <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
//               <div className="text-6xl mb-4">💼</div>
//               <h3 className="text-2xl font-bold text-gray-800 mb-4">
//                 No Offers Available
//               </h3>
//               <p className="text-gray-600 mb-6">
//                 Currently no offer available for you. We will meet in future
//                 with better opportunities.
//               </p>
//               <button
//                 onClick={handleOfferNotFoundPopupClose}
//                 className="bg-green-600 text-white font-bold py-3 px-6 rounded-xl w-full hover:bg-green-700 transition"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Success Popup */}
//         {showSuccessPopup && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//             <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
//               <div className="text-6xl mb-4">🎉</div>
//               <h3 className="text-2xl font-bold text-gray-800 mb-4">
//                 Congratulations!
//               </h3>
//               <p className="text-gray-600 mb-6">
//                 Your eligibility check is complete. You can now proceed to
//                 verify your email.
//               </p>
//               <button
//                 onClick={handleSuccessPopupClose}
//                 className="bg-green-600 text-white font-bold py-3 px-6 rounded-xl w-full hover:bg-green-700 transition"
//               >
//                 Continue to Email Verification
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LoanApp;

import React, { useEffect, useState } from "react";
import {
  FaCoins,
  FaChartLine,
  FaSignal,
  FaCheckCircle,
  FaArrowRight,
  FaDesktop,
  FaFileInvoiceDollar,
  FaSpinner,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import LoanEligibilitySDK, { SDKEvent } from "loan-eligibility-sdk";
import authService from "../../services/api/auth.service";
import axios from "axios";
import casdataService from "../../services/api/casdata.service";
import partnerService from "../../services/api/larkdata.service";
import fetchPortfolioData from "../../services/api/cas.service";

type SDKStatus = "idle" | "loading" | "success" | "error" | "completed";

interface ProfileData {
  data?: {
    phone_no: string;
    id: string;
    customer?: {
      application_status?: string;
    };
  };
  id?: string;
}

const LoanApp: React.FC = () => {
  const [sdk, setSdk] = useState<LoanEligibilitySDK | null>(null);
  const [status, setStatus] = useState<SDKStatus>("idle");
  const [message, setMessage] = useState("Check Eligibility");
  const [error, setError] = useState<string | null>(null);
  const [profile, setProfile] = useState<ProfileData | null>(null);
  const [showPortfolioNotFound, setShowPortfolioNotFound] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showOfferNotFoundPopup, setShowOfferNotFoundPopup] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);

  // Helper function to get the current domain with optional path
  const getDynamicRedirectUrl = (path = "") => {
    const currentDomain = window.location.origin;
    const domainMappings: Record<string, string> = {
      bajaj: "https://bajaj.com",
      otherbrand: "https://otherbrand.com",
    };
    const domainParts = window.location.hostname.split(".");
    const subdomain = domainParts.length > 2 ? domainParts[0] : null;
    if (subdomain && domainMappings[subdomain]) {
      return `${domainMappings[subdomain]}${path}`;
    }
    return `${currentDomain}${path}`;
  };

  // Helper function to get appropriate button message based on application status
  const getButtonMessage = (applicationStatus?: string) => {
    if (
      !applicationStatus ||
      applicationStatus === "null" ||
      applicationStatus === "PORTFOLIO_NOT_FOUND" ||
      applicationStatus === "OFFER_NOT_FOUND"
    ) {
      return "Check Eligibility";
    } else {
      return "Get Cash";
    }
  };

  // Helper function to handle redirect with loader
  const handleRedirectToVerifyEmail = () => {
    setIsRedirecting(true);
    setTimeout(() => {
      window.location.href = getDynamicRedirectUrl("/verify-email");
    }, 500);
  };

  const handleRedirectToLoanApply = () => {
    setIsRedirecting(true);
    setTimeout(() => {
      window.location.href = getDynamicRedirectUrl("/loan/apply");
    }, 500);
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await authService.getProfile();
        if (!data?.data?.phone_no) {
          throw new Error("Phone number not found in profile");
        }
        setProfile(data);
        const applicationStatus = data.data?.customer?.application_status;
        setMessage(getButtonMessage(applicationStatus));
      } catch (err) {
        console.error("Failed to fetch profile:", err);
        setError("Failed to fetch user profile");
      }
    };
    fetchProfile();
  }, []);

  const syncPortfolioData = async () => {
    if (!profile?.data?.phone_no) return;
    try {
      console.log("Starting automatic portfolio sync...");
      const result = await casdataService.syncPortfolioData(
        profile.data.id,
        profile.data.phone_no
      );
      if (result) {
        console.log("Portfolio data synced successfully:", result);
      } else {
        console.warn("Portfolio sync returned no data");
      }
    } catch (err) {
      console.error("Automatic portfolio sync failed:", err);
    }
  };

  const fetchLoanOffersUser = async (phoneNumber: string) => {
    try {
      const response = await axios.post(
        `https://api1-lark.larkfinserv.com/loan-sdk/get-offers`,
        {
          phone: `+91${phoneNumber}`,
        },
        {
          headers: {
            Origin: `${process.env.REACT_APP_RANDEEP_BACKEND_URL}`,
            Referer: `${process.env.REACT_APP_RANDEEP_BACKEND_URL}`,
            "X-SDK-Key": process.env.REACT_APP_SDK_KEY,
            "X-SDK-Secret": process.env.REACT_APP_SDK_SECRET,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching loan offers:", error);
      throw error;
    }
  };

  useEffect(() => {
    const initializeSdk = async () => {
      
      try {
         const sdkInstance = new LoanEligibilitySDK({
          apiKey: process.env.REACT_APP_SDK_KEY!,
          apiSecret: process.env.REACT_APP_SDK_SECRET!,
          phoneNumber: `+91${profile?.data?.phone_no}`,
        });
        
        const onInitiated = () => {
          setStatus("loading");
          setMessage("Loading eligibility check...");
        };

        const onReady = async () => {
          setMessage("Please complete the form");
        };

        const onCompleted = async (event: SDKEvent) => {
          try {
            setTimeout(() => {
              console.log("Eligibility Check Completed:", event.data);
            }, 5000);
            if (profile?.data?.id && profile?.data?.phone_no) {
              await partnerService.fetchPartnerProfile(profile?.data?.phone_no);
              await casdataService.syncPortfolioData(profile?.data?.id, profile?.data?.phone_no);
            }
            const resultMessage = (event.data?.result as any)?.message;
            if (
              resultMessage &&
              resultMessage.includes("No credit limit available")
            ) {
              console.log("No credit limit available for the user");
              setStatus("idle");
              setMessage(getButtonMessage("OFFER_NOT_FOUND"));
              setShowOfferNotFoundPopup(true);
              if (sdk) sdk.closeFrame();
              return;
            }
            if (
              resultMessage &&
              resultMessage.includes("User is not eligible for any offer")
            ) {
              if (profile?.data?.id) {
                await authService.updateApplicationStatus(
                  profile.data.id,
                  "OFFER_NOT_FOUND"
                );
              }
              setStatus("idle");
              setMessage(getButtonMessage("OFFER_NOT_FOUND"));
              setShowOfferNotFoundPopup(true);
              if (sdk) sdk.closeFrame();
              return;
            }
            if (profile?.data?.id && profile?.data?.phone_no) {
              const userData = await fetchLoanOffersUser(profile.data.phone_no);
              if (userData.data === null) {
                setStatus("error");
                setError("Sorry, you're not eligible for a loan at this time");
                setMessage(getButtonMessage(profile?.data?.customer?.application_status));
                if (sdk) sdk.closeFrame();
                return;
              }
              await authService.updateApplicationStatus(
                profile.data.id,
                "ELIGIBILITY_CHECKED"
              );
              setStatus("completed");
              setMessage("Get Cash");
              setShowSuccessPopup(true);
              syncPortfolioData();
            }
          } catch (err) {
            console.error("Failed to update application status:", err);
            if (sdk) sdk.closeFrame();
          }
        };

        const onError = (event: SDKEvent) => {
          setStatus("error");
          setError(event.data?.error?.message || "An error occurred");
          setMessage(getButtonMessage(profile?.data?.customer?.application_status));
          console.error("SDK Error:", event);
        };

        const onClosed = () => {
          console.log("sdk closed from closed button");
          setStatus("idle");
          setMessage(getButtonMessage(profile?.data?.customer?.application_status));
          if (sdk) sdk.closeFrame();
        };

        // SINGLE handler for CLOSE_FRAME, now async and calls your two functions
        const onCloseFrame = async (event: SDKEvent) => {
          console.log("SDK CLOSE_FRAME event received", event);

          if (profile?.data?.phone_no && profile?.data?.id) {
            try {
              await partnerService.fetchPartnerProfile(profile.data.phone_no);
              await casdataService.syncPortfolioData(profile.data.id, profile.data.phone_no);
              console.log("Partner profile and portfolio data synced on CLOSE_FRAME");
            } catch (err) {
              console.error("Error syncing data on CLOSE_FRAME:", err);
            }
          }

          setStatus("idle");
          setShowPortfolioNotFound(false);
          setShowOfferNotFoundPopup(false);
          setShowSuccessPopup(false);
          setError(null);
          setMessage(getButtonMessage(profile?.data?.customer?.application_status));
          if (sdk) sdk.closeFrame();
        };

        sdkInstance.on("INITIATED", onInitiated);
        sdkInstance.on("READY", onReady);
        sdkInstance.on("ELIGIBILITY_RESULT", onCompleted);
        sdkInstance.on("ERROR", onError);
        sdkInstance.on("CLOSE", onClosed);
        sdkInstance.on("CLOSE_FRAME", onCloseFrame);

        setSdk(sdkInstance);

        return () => {
          sdkInstance.off("INITIATED", onInitiated);
          sdkInstance.off("READY", onReady);
          sdkInstance.off("ELIGIBILITY_RESULT", onCompleted);
          sdkInstance.off("ERROR", onError);
          sdkInstance.off("CLOSE", onClosed);
          sdkInstance.off("CLOSE_FRAME", onCloseFrame);
          sdkInstance.closeFrame();
        };
      } catch (err) {
        setStatus("error");
        setError("Failed to initialize SDK");
        setMessage(getButtonMessage(profile?.data?.customer?.application_status));
        console.error("Initialization error:", err);
      }
    };

    if (profile?.data?.phone_no) {
      initializeSdk();
    }
    // eslint-disable-next-line
  }, [profile]);

  const handleClick = async () => {
    if (!profile || !profile.data || !profile.data.phone_no) {
      setError("Phone number not available");
      return;
    }
    let applicationStatus = profile.data.customer?.application_status;
    if (!applicationStatus) applicationStatus = "null";
    switch (applicationStatus.toUpperCase()) {
      case "NULL":
      case "PORTFOLIO_NOT_FOUND":
        if (!sdk) {
          setError("SDK not initialized");
          return;
        }
        try {
          setError(null);
          await sdk.initialize({
            apiKey: process.env.REACT_APP_SDK_KEY!,
            apiSecret: process.env.REACT_APP_SDK_SECRET!,
            phoneNumber: `+91${profile.data.phone_no}`,
          });
          sdk.openEligibilityCheck("inline");
        } catch (err) {
          setStatus("error");
          setError("Failed to open eligibility check");
          setMessage(getButtonMessage(applicationStatus));
          console.error("Open error:", err);
          if (sdk) sdk.closeFrame();
        }
        break;
      case "EMAIL_VERIFIED":
        handleRedirectToLoanApply();
        break;
      case "ELIGIBILITY_CHECKED":
      default:
        if (
          applicationStatus.toUpperCase() !== "PORTFOLIO_NOT_FOUND" &&
          applicationStatus.toUpperCase() !== "OFFER_NOT_FOUND" &&
          applicationStatus.toUpperCase() !== "NULL"
        ) {
          handleRedirectToLoanApply();
        } else {
          handleRedirectToVerifyEmail();
        }
        break;
    }
  };

  const handleSuccessPopupClose = () => {
    setShowSuccessPopup(false);
    if (sdk) sdk.closeFrame();
    handleRedirectToVerifyEmail();
  };

  const handleOfferNotFoundPopupClose = () => {
    setShowOfferNotFoundPopup(false);
    setError(null);
    setMessage(getButtonMessage("OFFER_NOT_FOUND"));
    if (sdk) sdk.closeFrame();
  };

  return (
    <div className="min-h-screen p-5 font-sans">
      {/* Redirect Loader Overlay */}
      {isRedirecting && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
            <div className="mb-4">
              <FaSpinner className="text-green-600 text-4xl mx-auto animate-spin" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              Redirecting...
            </h3>
            <p className="text-gray-600">
              Please wait while we redirect you to the next step.
            </p>
          </div>
        </div>
      )}

      <div className="max-w-6xl mx-auto bg-white shadow-2xl rounded-3xl overflow-hidden border border-gray-100">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-green-600 to-green-800 text-white p-8 relative">
          <div className="absolute inset-0 opacity-10 bg-pattern"></div>
          <div className="relative">
            <div className="flex justify-between items-center">
              <div>
                <h1 className="text-4xl font-bold mb-4 tracking-tight">
                  Instant Cash Against Mutual Funds
                </h1>
                <p className="text-xl text-green-100 mb-6">
                  Unlock financial flexibility without selling your investments
                </p>
              </div>
              <div className="bg-white/20 p-4 rounded-2xl">
                <div className="flex space-x-4">
                  <div className="text-center">
                    <span className="block text-sm text-green-100">
                      Credit Card
                    </span>
                    <span className="font-bold text-white text-lg">35%</span>
                  </div>
                  <div className="text-center">
                    <span className="block text-sm text-green-100">
                      Personal Loan
                    </span>
                    <span className="font-bold text-white text-lg">18%</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex items-center space-x-4">
              <button
                onClick={handleClick}
                className={`bg-white text-green-800 hover:bg-green-50 font-bold py-3 px-6 rounded-xl transition transform hover:scale-105 flex items-center space-x-2 ${
                  status === "loading" || isRedirecting
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                disabled={status === "loading" || isRedirecting}
              >
                {isRedirecting ? (
                  <>
                    <FaSpinner className="animate-spin" />
                    <span>Redirecting...</span>
                  </>
                ) : (
                  <>
                    <span>{status === "loading" ? "Loading..." : message}</span>
                    <FaArrowRight />
                  </>
                )}
              </button>
              <div className="bg-white/20 px-4 py-2 rounded-xl">
                <span className="text-lg font-semibold">
                  Loans Up to ₹5 Crores
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-6 p-8">
          <button className="bg-green-50 border border-green-100 rounded-2xl p-6 hover:shadow-xl transition-all group">
            <div className="flex items-center justify-between mb-4">
              <FaCoins className="text-green-600 text-3xl" />
              <span className="text-green-700 font-bold text-xl">
                Start from 10.25% p.a.
              </span>
            </div>
            <h3 className="text-xl font-bold text-green-800 mb-2">
              Loan Against Mutual Fund <FaArrowRight />
            </h3>
            <p className="text-green-700">
              Better rates than traditional personal loans
            </p>
          </button>

          <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6 hover:shadow-xl transition-all group">
            <div className="flex items-center justify-between mb-4">
              <FaChartLine className="text-blue-600 text-3xl" />
              <span className="text-blue-700 font-bold text-xl">50% LTV</span>
            </div>
            <h3 className="text-xl font-bold text-blue-800 mb-2">
              Loan Against Stocks
            </h3>
            <p className="text-blue-700">
              Get loan value against your stock portfolio
            </p>
          </div>

          <button className="bg-purple-50 border border-purple-100 rounded-2xl p-6 hover:shadow-xl transition-all group">
            <div className="flex items-center justify-between mb-4">
              <FaSignal className="text-purple-600 text-3xl" />
              <FaCheckCircle className="text-green-500" />
            </div>
            <h3 className="text-xl font-bold text-purple-800 mb-2">
              Quick Eligibility <FaArrowRight />
            </h3>
            <p className="text-purple-700">
              Instant digital verification process
            </p>
          </button>
        </div>

        {/* Benefits */}
        <div className="bg-gray-100 p-8 grid md:grid-cols-2 gap-8">
          <div>
            <h2 className="text-3xl font-bold text-green-800 mb-6">
              Why Choose Us?
            </h2>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <FaDesktop className="text-green-600 text-2xl mt-1" />
                <div>
                  <h4 className="font-bold text-green-800 mb-2">
                    100% Digital Process
                  </h4>
                  <p className="text-gray-600">
                    Paperless application with instant processing
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <FaFileInvoiceDollar className="text-blue-600 text-2xl mt-1" />
                <div>
                  <h4 className="font-bold text-blue-800 mb-2">
                    Zero Pre-Closure Charges
                  </h4>
                  <p className="text-gray-600">
                    Complete flexibility in loan repayment
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h2 className="text-3xl font-bold text-green-800 mb-6">
              How It Works
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Loan Against Securities (LAS) is a secure way to leverage your
              investments. Pledge your mutual funds or stocks as collateral and
              access funds without disrupting your investment strategy.
            </p>
          </div>
        </div>

        {/* CTA Footer */}
        <div className="bg-green-700 text-white text-center p-12">
          <h3 className="text-3xl font-bold mb-6">
            Get Instant Financial Flexibility
          </h3>
          <button
            onClick={handleClick}
            className={`bg-white w-fit text-green-800 hover:bg-green-50 font-bold py-4 px-10 rounded-xl 
              transition transform hover:scale-105 flex items-center space-x-3 mx-auto ${
                status === "loading" || isRedirecting
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            disabled={status === "loading" || isRedirecting}
          >
            {isRedirecting ? (
              <>
                <FaSpinner className="animate-spin" />
                <span className="text-lg">Redirecting...</span>
              </>
            ) : (
              <>
                <span className="text-lg">
                  {status === "loading" ? "Loading..." : message}
                </span>
                <FaArrowRight />
              </>
            )}
          </button>
        </div>

        {/* Error Message */}
        {error && (
          <div className="p-4 text-red-500 text-center">
            <p>{error}</p>
          </div>
        )}

        {/* Portfolio Not Found Popup */}
        {showPortfolioNotFound && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Portfolio Not Found
              </h3>
              <p className="text-gray-600 mb-6">
                We couldn't find your investment portfolio. Please check your
                details and try again.
              </p>
              <button
                onClick={() => {
                  setShowPortfolioNotFound(false);
                  setError(null);
                  setMessage(getButtonMessage("PORTFOLIO_NOT_FOUND"));
                  if (sdk) sdk.closeFrame();
                }}
                className="bg-green-600 text-white font-bold py-3 px-6 rounded-xl w-full hover:bg-green-700 transition"
              >
                Close
              </button>
            </div>
          </div>
        )}

        {/* Offer Not Found Popup */}
        {showOfferNotFoundPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
              <div className="text-6xl mb-4">💼</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                No Offers Available
              </h3>
              <p className="text-gray-600 mb-6">
                Currently no offer available for you. We will meet in future
                with better opportunities.
              </p>
              <button
                onClick={handleOfferNotFoundPopupClose}
                className="bg-green-600 text-white font-bold py-3 px-6 rounded-xl w-full hover:bg-green-700 transition"
              >
                Close
              </button>
            </div>
          </div>
        )}

        {/* Success Popup */}
        {showSuccessPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
              <div className="text-6xl mb-4">🎉</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Congratulations!
              </h3>
              <p className="text-gray-600 mb-6">
                Your eligibility check is complete. You can now proceed to
                verify your email.
              </p>
              <button
                onClick={handleSuccessPopupClose}
                className="bg-green-600 text-white font-bold py-3 px-6 rounded-xl w-full hover:bg-green-700 transition"
              >
                Continue to Email Verification
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoanApp;
